export const BASE_URL = 'https://may-flower-server-bj9s.vercel.app'

// export const BASE_URL = 'http://localhost:5000'